import { useEffect, useState } from "react";

// Tiny global store of currently-live sessions so avatars across the app can show
// a red "live" ring and let people tap to join. Fed by ChatApp polling /live/active.
let sessions = [];
const subs = new Set();

export const setLiveSessions = (arr) => {
  sessions = Array.isArray(arr) ? arr : [];
  subs.forEach((f) => f(sessions));
};
export const liveSessionFor = (uid) => sessions.find((s) => s.host_id === uid);

export function useLiveSessions() {
  const [list, setList] = useState(sessions);
  useEffect(() => {
    const f = (s) => setList([...s]);
    subs.add(f);
    return () => subs.delete(f);
  }, []);
  return list;
}

export function useIsLive(uid) {
  const list = useLiveSessions();
  return uid ? list.find((s) => s.host_id === uid) || null : null;
}
